import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import { connect } from 'react-redux';
import asyncComponent from '../helpers/AsyncFunc';
import InjectIntlFormatComponent from '../helpers/InjectIntlFormatComponent';
import { basePath, baseRouterPath } from './baseRouter';

const RestrictedRoute = ({ component: Component, isLoggedIn, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isLoggedIn ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: basePath,
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

const PublicRoutes = ({ history, isLoggedIn }) => (
  <ConnectedRouter history={history}>
    <div>
      <InjectIntlFormatComponent />
      <Route exact path={basePath} component={asyncComponent(() => import('./Page/Login'))} />
      <Route exact path="/404" component={asyncComponent(() => import('../containers/Page/404'))} />
      <Route exact path="/500" component={asyncComponent(() => import('../containers/Page/500'))} />
      <Route exact path="/signin" component={asyncComponent(() => import('./Page/Login'))} />
      {/* 登入後才獲取dashboard列表，因登入後才獲取permission以及驗證permission */}
      {isLoggedIn && (
        <RestrictedRoute
          path={baseRouterPath}
          component={asyncComponent(() => import('./Dashboard/App.jsx'))}
          isLoggedIn={isLoggedIn}
        />
      )}
    </div>
  </ConnectedRouter>
);

export default connect(state => ({
  isLoggedIn: state.Auth.idToken !== null,
}))(PublicRoutes);
